import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AccountService } from '../../services/account.service';
import { HttpService } from '../../http/http.service';
import { IImageFile } from '../../interfaces/files.interface';
import { ApiEndpointService } from '../../services/api-endpoint.service';

export enum FileManagerTypeEnum {
  ALL,
  IMAGES,
  DOCUMENTS,
  CONTACT,
  USER,
  LAYOUTS
}

export enum OrderByEnum {
  CreatedOn = 'CreatedOn',
  Name = 'Name'
}

export enum OrderDirectionEnum {
  DESC = 'DESC',
  ASC = 'ASC'
}

export interface IGetFilesByFolderRequestDetails {
  Count: number;
  OrderBy: OrderByEnum;
  OrderByDirection: OrderDirectionEnum;
  Page: number;
  FileManagerType: FileManagerTypeEnum;
  searchCondition: string;
  folderId: string;
  isCountChanged: boolean;
  SearchAllFolders: boolean;
  ExcludeFolders: boolean;
}

@Injectable()
export class CDFileManagerAPI {
  private readonly baseUrlFileManager: string;

  constructor(
    private httpService: HttpService,
    private accountService: AccountService,
    private apiEndpoint: ApiEndpointService
  ) {
    this.baseUrlFileManager = `${this.accountService.baseUrl}/api/FileManager_v2/`;
  }

  private getAccountDataQueryString = (fileManagerTypeEnum: FileManagerTypeEnum): string => {
    const accountKey = this.accountService.accountKey;
    const pageid = this.accountService.pageid;
    const typename = this.accountService.typename;
    const orgname = this.accountService.orgname;
    return `accountKey=${accountKey}&id=${pageid}&orgname=${orgname}&typename=${typename}&callerpage=ddeditor&type=${fileManagerTypeEnum}`;
  }

  public deleteFile = (fileId: string, fileManagerTypeEnum: FileManagerTypeEnum): Observable<any> => {
    const action = 'FilesList/deletefile';
    const param = `id=${fileId}`;
    const accountData = this.getAccountDataQueryString(fileManagerTypeEnum);
    return this.httpService.get(`${this.baseUrlFileManager}${action}/?${param}&${accountData}`);
  }

  public getUrlForUploadFiles = (folderId: string, fileManagerTypeEnum: FileManagerTypeEnum): string => {
    const action = 'FileUploader/upload';
    const accountData = this.getAccountDataQueryString(fileManagerTypeEnum);
    return `${this.baseUrlFileManager}${action}/?parentFolderId=${folderId}&${accountData}`;
  }

  public saveFileFromPixie = (originalFile: IImageFile, fileData: any): Observable<any> => {
    const postedFile = {
      ContentType: 'image/jpeg',
      Id: originalFile.id,
      Link: originalFile.src,
      Name: originalFile.name,
      ParentFolderId: originalFile.parentFolderId,
      Size: originalFile.size,
      Width: originalFile.width,
      Height: originalFile.height,
    };
    const data = { originalFile: postedFile, fileData: fileData };
    return this.httpService.post(data, this.apiEndpoint.CreateFromPixieUrl);
  }

  public getBlobData(): Observable<any> {
    return this.httpService.get(this.apiEndpoint.GetBlobDataUrl);
  }
}

